module.exports = __webpack_public_path__ + "img/Close_L3.8751fd84.svg";